/** Envelope de resposta e codigos de erro compartilhados entre API e front. */
export const API_ERROR_CODES = [
    'bad_request',
    'validation_failed',
    'unauthenticated',
    /**
     * Login com senha certa e segundo fator faltando ou errado.
     *
     * Sao 401 como qualquer credencial recusada, mas precisam de codigo proprio:
     * a tela usa isto para pedir o codigo em vez de dizer que a senha esta
     * errada. Quem chega neste ponto ja provou a senha, entao distinguir nao
     * entrega nada a um estranho.
     */
    'totp_required',
    'totp_invalid',
    'forbidden',
    'not_found',
    'conflict',
    'plan_limit_reached',
    'module_not_available',
    'subscription_inactive',
    /** A Azko cortou o acesso da conta. Nao e falta de plano nem de permissao. */
    'account_suspended',
    'rate_limited',
    'internal_error',
];
export function isApiError(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'error' in value &&
        typeof value.error?.code === 'string');
}
//# sourceMappingURL=api.js.map